import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0467d2e9&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0467d2e9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0467d2e9')) {
      api.createRecord('0467d2e9', component.options)
    } else {
      api.reload('0467d2e9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0467d2e9&scoped=true&", function () {
      api.rerender('0467d2e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/seikyu/index.vue"
export default component.exports